import { util } from '@/api/util';
export const transTeamToOrg = (list) => {
    const orgList = [];
    list.forEach(item => {
        const { teamId, serverCustom, avatar, intro, name, announcement, owner, memberNum, memberUpdateTime, createTime, updateTime } = item;
        const type = 2000;
        const id = 'team_' + teamId;
        const parent = 'team';
        const originId = 'team_' + teamId;
        const orgRank = createTime;
        let orgName = name || '';
        const visibleCode = 0;
        if (!orgName || orgName.includes('LINGXI_IM_TEAM_DEFAULT_NAME')) {
            try {
                const customObj = JSON.parse(serverCustom);
                orgName = customObj.auto_team_name || orgName;
            }
            catch (e) {
                console.error('[contact] transTeamToOrg SON.parse serverCustom', e);
            }
        }
        const orgPYName = util.toPinyin(orgName);
        orgList.push({
            id,
            parent,
            orgName,
            orgPYName,
            orgRank,
            type,
            visibleCode,
            originId,
            avatar,
            intro,
            announcement,
            owner,
            memberNum,
            memberUpdateTime,
            createTime,
            updateTime,
            _lastUpdateTime: updateTime,
        });
    });
    return orgList;
};
export const transServerTeamMemberList = (item) => {
    const { tid: teamId, owner, admins, members } = item;
    let teamMember = [];
    teamMember = members.concat([
        Object.assign(Object.assign({}, owner), { type: 'owner' }),
        ...admins.map((adminMember) => (Object.assign(Object.assign({}, adminMember), { type: 'manage' }))),
    ]);
    return teamMember.map((memberItem) => {
        const { type, nick: nickInTeam, createtime: joinTime, accid: account } = memberItem;
        return {
            type: type || 'normal',
            nickInTeam,
            joinTime,
            teamId,
            account,
        };
    });
};
export const transServerTeamList = (list) => {
    const teamMemberMap = {};
    const teamList = list.map(item => {
        const { icon: avatar, intro, announcement, owner, member_update_time: memberUpdateTime, createtime: createTime, updatetime: updateTime, custom: serverCustom, tname: name, tid: teamId, } = item;
        const ownerId = owner.accid;
        const memberList = transServerTeamMemberList(item);
        teamMemberMap[teamId] = memberList;
        return {
            serverCustom,
            name,
            teamId,
            avatar,
            intro,
            announcement,
            owner: ownerId,
            memberNum: memberList.length,
            memberUpdateTime,
            createTime,
            updateTime,
        };
    });
    return {
        teamList,
        teamMemberMap,
    };
};
